import { css } from "@emotion/react";
import * as icomoonVars from "./fonts/tripper-icons/variables";

export { icomoonVars };

export const increaseHitZone = ({ val = "0.5em" } = {}) => css`
    position: relative;

    &:after {
        position: absolute;
        top: -${val};
        right: -${val};
        bottom: -${val};
        left: -${val};
        content: " ";
    }
`;

export const resetButton = css`
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    appearance: none;
    background-color: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: block;
    font-family: inherit;
    outline: none;
    padding: 0;
`;

export const visuallyHidden = css`
    border: 0px none;
    clip: rect(0px, 0px, 0px, 0px);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0px;
    position: absolute;
    width: 1px;
`;

export const icomoonIcon = css`
    font-family: "${icomoonVars.fontFamily}" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    letter-spacing: 0;
    -ms-font-feature-settings: "liga" 1;
    font-feature-settings: "liga", normal, "dlig";
    font-variant-ligatures: discretionary-ligatures;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;
